import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCategory, getContent, createContent, updateContent, uploadImg} from '../../features/notice/noticeSlice';
import { Editor } from '@tinymce/tinymce-react';
import { useNavigate, useParams, useLocation  } from "react-router-dom";
import { Form, Button, Row, Col} from 'react-bootstrap';
import api from '../../utils/api';


function ContentInputPage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { noticeId } = useParams();
    const [editorContent, setEditorContent] = useState('');
    const [title, setTitle] = useState('');
    const [file1, setFile1] = useState(null);  
    const [file2, setFile2] = useState(null);
    const [link, setLink] = useState(null);
    const categories = useSelector((state) => state.notice.categories); 
    const [category, setCategory] = useState(''); 
    const apiBaseURL = api.defaults.baseURL;
    const files = useSelector((state) => state.notice.files);
    const previewDB = useSelector((state) => state.notice.preview);

    //region useEffect
    useEffect(() => { 
        const initializeContent = async () => {
          dispatch(getCategory());
          // noticeId가 있으면 게시글 수정
          if (noticeId) {
            try {
              const response = await dispatch(getContent({ noticeId }));
              const contentData = response.payload.content;
              setTitle(contentData.title);
              setEditorContent(contentData.content);
              setCategory(contentData.category_id);
              setLink(contentData.link);
              setFile1(files.length > 0 ? files[0] : null);
              setFile2(files.length > 1 ? files[1] : null);
            } catch (error) {
              //console.error('컨텐츠 로딩 실패:', error);
            }
          }
        };
      
        initializeContent();
      }, [dispatch, noticeId]);

    const handleCategoryChange = (e) => {
        setCategory(e.target.value); 
    };
    //#endregion

     //#region 에디터 내 이미지 업로드
    const handleFileUpload = (blobInfo, progress) => new Promise (async (resolve, reject) => {
        try {
            if (blobInfo.blob().size > 20 * 1024 * 1024) {
                alert('20MB를 초과하는 이미지는 업로드할 수 없습니다.');
                reject('이미지 용량 초과');
                return;
            }
            const formData = new FormData();
            formData.append('image', blobInfo.blob(), blobInfo.filename());
    
            const config = {
                onUploadProgress: (event) => {
                    progress((event.loaded / event.total) * 100); 
                },
            };
            
            const response = await dispatch(uploadImg({
                data: formData, 
                endpoint: '/file/image',
                config
            })).unwrap();
    
            if (response && response.filePvSeq) {
                const uploaded_url = `${apiBaseURL}/file/view?id=${response.filePvSeq}`;
                // console.log('이미지 업로드 성공')
                resolve(uploaded_url);

            } else if(response && response.uploaded_url) {
                resolve(response.uploaded_url);
            } else {
                // console.error('Invalid server response: ', response);
                reject('이미지 업로드 실패');
            }
        } catch (error) {
            // console.error('이미지 업로드 실패: ', error);
            reject('서버 오류: ' + error.message);
        }
    });

    //#endregion
    
    //#region 입력값 설정
    const handleTitleChange = (event) => {
        setTitle(event.target.value);
    };

    const handleLinkChange = (event) => {
        setLink(event.target.value);
    };

    const handleFileChange1 = (event) => {
        const file = event.target.files[0];  
        if (file && file.size > 20 * 1024 * 1024) {
            alert('20MB를 초과하는 파일은 업로드할 수 없습니다.');
            return;
        }
        setFile1(file);
    };

    const handleFileChange2 = (event) => {
        const file = event.target.files[0]; 
        if (file && file.size > 20 * 1024 * 1024) {
            alert('20MB를 초과하는 파일은 업로드할 수 없습니다.');
            return;
        }
        setFile2(file);
    };

    //이미지태그 에서 id 또는 파일명 추출
    function extractImgs(editorContent) {
        const imgTagRegex = /<img [^>]*src="([^"]+)"[^>]*>/g;
        const imgs = [];
        let match;
      
        while ((match = imgTagRegex.exec(editorContent)) !== null) {
          const src = match[1];
          const idMatch = src.match(/id=(\d+)/);
      
          if (idMatch) {
            imgs.push(idMatch[1]);
          } else {
            try {
              const urlObj = new URL(src);
              const pathParts = urlObj.pathname.split('/');
              const fileName = pathParts[pathParts.length - 1];
      
              // 실제 이미지 확장자인 경우만
              if (/\.(jpg|jpeg|png|gif|webp)$/i.test(fileName)) {
                imgs.push(fileName);
              }
            } catch (e) {
              // src가 잘못된 URL이면 무시
            }
          }
        }
      
        return imgs;
      }
      
      
    const imgs = extractImgs(editorContent);
    
    //#endregion
    
    //#region 미리보기로 등록
    const submitPreview = async (event) => {
        event.preventDefault();

        if (category === '') {
            alert("카테고리를 선택해주세요");
            return;
        }

        if (!title.trim()) {
            alert("제목을 입력해주세요");
            return;
        }

        const data = {
            categoryId: category,
            title,
            content: editorContent,
            relatedLink: link || null,
            imgs,
            preview: "Y" 
        };

        const formData = new FormData();
        if (file1) formData.append('file1', file1);
        if (file2) formData.append('file2', file2);

        formData.append('data', JSON.stringify(data));

        const endpoint = file1 || file2 ? "/content/files" : "/content";

        localStorage.setItem("activeCategory", JSON.stringify({
            categoryId: category,
            categoryName: categories.find(c => c.id === category)?.name || ''
          }));

        try {
            await dispatch(createContent({ data: formData, endpoint })).unwrap();
            alert('게시글 임시저장 성공');
            navigate('/notice');

        } catch (error) {
            // console.error("오류 세부사항:", error);
            alert(`임시저장 실패: [ ${error} ]`);
        }
    }
    //#endregion

    //#region 개시글 등록
    const submitContent = async (event) => {
        event.preventDefault();

        if (category === '') {
            alert("카테고리를 선택해주세요");
            return;
        }

        if (!title.trim()) {
            alert("제목을 입력해주세요");
            return;
        }

        const data = {
            categoryId: category,
            title,
            content: editorContent,
            relatedLink: link || null,
            imgs,
            preview: "N"
        };

        const formData = new FormData();
        if (file1) formData.append('file1', file1);
        if (file2) formData.append('file2', file2);

        formData.append('data', JSON.stringify(data));

        const endpoint = file1 || file2 ? "/content/files" : "/content";

        localStorage.setItem("activeCategory", JSON.stringify({
            categoryId: category,
            categoryName: categories.find(c => c.id === category)?.name || ''
          }));

        try {
            const result = await dispatch(createContent({ data: formData, endpoint })).unwrap();

            alert('게시글 작성 성공');

            const url = `${process.env.SITE_URL}/notice/${result.contentId}`;
            const badyData = "새로운 게시글이 등록되었습니다"

            await sendLocalNotification(url, badyData); 
            navigate('/notice');

        } catch (error) {
            alert(`콘텐츠 저장 실패: [ ${error} ]`);
        }
    };
    //#endregion

    //#region 게시글 수정
    const updateContent = async (event) => {
        event.preventDefault();
        console.log(editorContent)
        const data = {
            category_id: category,
            title,
            content: editorContent,
            link: link || null,
            imgs: imgs || null,
            preview : previewDB
        };
      
        const formData = new FormData();
        if (file1) formData.append('file1', file1);
        if (file2) formData.append('file2', file2);
      
        formData.append('data', JSON.stringify(data));
      
        localStorage.setItem("activeCategory", JSON.stringify({
            categoryId: category,
            categoryName: categories.find(c => c.id === category)?.name || ''
        }));
        
        try {
          const response = await api.put(`/content/${noticeId}`, formData);

          if (response.status === 200) {

            const url = `http://localhost:3000/notice/${noticeId}`;
            const badyData = `게시글 수정 : ${title}`

            await sendLocalNotification(url, badyData); 

            alert('게시글 수정 성공');
            if (location.state?.from) {
                window.location.href = location.state.from; 
            } else {
                window.location.href = "/notice"; 
            }
          } else {
            throw new Error('Failed to update content');
          }
        } catch (error) {
          // console.error("오류 세부사항:", error);
          alert(`콘텐츠 저장 실패: [ ${error.message || error} ]`);
        }
      };
    //#endregion

    //#region 미리보기로 수정
    const updatePreview = async (event) => {
        event.preventDefault();
        
        const data = {
            category_id: category,
            title,
            content: editorContent,
            link: link || null,
            imgs: imgs || null,
            preview: "N"
        };
      
        const formData = new FormData();
        if (file1) formData.append('file1', file1);
        if (file2) formData.append('file2', file2);
      
        formData.append('data', JSON.stringify(data));
      
        localStorage.setItem("activeCategory", JSON.stringify({
            categoryId: category,
            categoryName: categories.find(c => c.id === category)?.name || ''
          }));
        
        try {
          const response = await api.put(`/content/${noticeId}`, formData);

          if (response.status === 200) {
            alert('수정 및 전체공개 성공');
            if (location.state?.from) {
                window.location.href = location.state.from; 
            } else {
                window.location.href = "/notice"; 
            }
          } else {
            throw new Error('Failed to update content');
          }
        } catch (error) {
          // console.error("오류 세부사항:", error);
          alert(`콘텐츠 저장 실패: [ ${error.message || error} ]`);
        }
      };
    //#endregion

    //#region 게시글로 이동
    const onClickNotice = () => {
        if (location.state?.from) {
          navigate(location.state.from);
        } else {
          navigate("/notice");
        }
      };


    //#region 알림 테스트
    const sendLocalNotification = async (notiUrl, bodyData) => {
        const reg = await navigator.serviceWorker.ready;

        reg.showNotification("위즈팩토리", {
            body: bodyData,
            icon: "/logo192.png",
            data: { notiUrl },
        });
    };
    //#endregion

    return (
        <div className="flex-1">
            <div className="bo_inner">
                    <Form.Group controlId="category" className="mb-3">
                        <Form.Label>카테고리 선택</Form.Label>
                        <Form.Control as="select" value={category} onChange={handleCategoryChange}>
                            <option value='' disabled>카테고리 선택</option>
                            {categories && categories.length > 0 ? (
                                categories.map((category) => (
                                    <option key={category.id} value={category.id}>
                                        {category.name}
                                    </option>
                                ))
                            ) : (
                                <option>카테고리 로딩 중...</option>
                            )}
                        </Form.Control>
                    </Form.Group>

                    <Form.Group controlId="title" className="mb-3">
                        <Form.Label>제목</Form.Label>
                        <Form.Control
                            type="text"
                            value={title}
                            onChange={handleTitleChange}
                            placeholder="제목을 입력하세요"
                            required
                        />
                    </Form.Group>

                    {category !== 'DATAROOM' && (
                        <Form.Group controlId="content" className="mb-3">
                            <Form.Label>내용</Form.Label>
                            <Editor
                                apiKey={process.env.REACT_APP_TINY_API_KEY}
                                value={editorContent}
                                init={{
                                    selector: 'textarea#default-editor',
                                    language: 'ko_KR',
                                    language_url: '/tinyMCE/langs/ko_KR.js',
                                    plugins: ['image', 'link', 'lists', 'table', 'visualblocks', 'wordcount', 'media'],
                                    toolbar: 'undo redo | blocks fontsize | fontsizeInput | forecolor backcolor | bold italic underline strikethrough | numlist bullist lineheight | alignjustify alignleft aligncenter alignright | media link image | ',
                                    images_upload_handler: handleFileUpload,
                                    automatic_uploads: true,
                                    height: 800,
                                    content_style: `
                                        h1, h2, h3, h4, h5, p {
                                            margin: 0 !important;
                                            padding: 0 !important;
                                        }
                                    `,
                                }}
                                onEditorChange={(content) => setEditorContent(content)}
                            />
                        </Form.Group>
                    )}

                    <Form.Group controlId="link" className="mb-3">
                        <Form.Label>관련링크</Form.Label>
                        <Form.Control
                            type="text"
                            value={link}
                            onChange={handleLinkChange}
                            placeholder="관련링크를 입력하세요"
                        />
                    </Form.Group>

                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="file1">
                                <Form.Label>파일 1</Form.Label>
                                {!file1 ? (
                                    <Form.Control type="file" onChange={handleFileChange1} />
                                ) : (
                                    <div className="d-flex align-items-center">
                                        <Form.Control type="text" value={file1.name} readOnly />
                                        <button
                                            type="button"
                                            className="btn btn-danger ms-2"
                                            onClick={() => setFile1(null)} // 삭제 버튼 클릭 시 file1 초기화
                                        >
                                            삭제
                                        </button>
                                    </div>
                                )}
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group controlId="file2">
                                <Form.Label>파일 2</Form.Label>
                                {!file2 ? (
                                    <Form.Control type="file" onChange={handleFileChange2} />
                                ) : (
                                    <div className="d-flex align-items-center">
                                        <Form.Control type="text" value={file2.name} readOnly />
                                        <button
                                            type="button"
                                            className="btn btn-danger ms-2"
                                            onClick={() => setFile2(null)} // 삭제 버튼 클릭 시 file2 초기화
                                        >
                                            삭제
                                        </button>
                                    </div>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className='btn-right'>
                        {!noticeId ? (
                            <>
                                <Button variant="outline-primary" onClick={submitPreview} className="mt-3">
                                    임시저장
                                </Button>
                                <Button variant="primary" onClick={submitContent} className="mt-3">
                                    등록
                                </Button>
                            </>
                        ) : (
                            <>
                                {previewDB === 'Y' && (
                                    <Button variant="outline-primary" onClick={updatePreview} className="mt-3">
                                    전체공개
                                    </Button>
                                )}

                                <Button variant="primary" onClick={updateContent} className="mt-3">
                                    수정
                                </Button>
                            </>
                        )}

                        <Button variant="secondary" onClick={onClickNotice} className="mt-3">
                            취소
                        </Button>
                    </div>
                    
            </div>
        </div>
    );
}

export default ContentInputPage;
